/* Mobile accordions for the product-description section (description /
   product details / key features / size chart), per owner's request -
   collapsible, closed by default on mobile. Desktop keeps every panel
   open via CSS (llm-product-description.css force-shows them), so this
   toggle is only meaningful below that breakpoint; harmless above it. */
(function () {
  document.querySelectorAll('.llm-pd-accordion__header').forEach(function (header) {
    header.addEventListener('click', function () {
      var acc = header.closest('.llm-pd-accordion');
      if (!acc) return;
      var isOpen = acc.classList.toggle('is-open');
      header.setAttribute('aria-expanded', String(isOpen));
    });
  });
})();
